// extracted by mini-css-extract-plugin
export var aircallIframe = "_ky-3";
export var fabContainer = "_ky-5";
export var fabRinging = "_ky-6";
export var loadingOverlay = "_ky-4";
export var pulse = "_ky-7";
export var widgetContent = "_ky-2";
export var widgetPanel = "_ky-0";
export var widgetPanelExpanded = "_ky-1";